// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

/** The algorithms used to wrap/unwrap data encryption key with key encryption key.  */
export enum KeyEncryptionAlgorithm {
  /** name of supported algo */
  RSA_OAEP = "RSA-OAEP",
}
